import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EndpointsService } from './endpoints.service';
import { GdprConsentComponent } from '../popup/gdpr-consent/gdpr-consent.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GdprConsentService {
  private shown = false;

  constructor(
    private http: HttpClient,
    private endpointService: EndpointsService,
    private modalService: BsModalService,

  ) {}

  showOnce() {
    if (!this.shown) {
      this.shown = true;
      this.modalService.show(GdprConsentComponent, {
              class: 'modal-dialog-centered',
              ignoreBackdropClick: true
            });
            console.log('GDPR consent modal should be shown (only once per session).');
          }
  }


  reset() {
    this.shown = false;
  }

  async registerGdprConsent(consentGiven: boolean) {
    try {
      await firstValueFrom(
        this.http.post(
          this.endpointService.gdprConsent,
          consentGiven,
          this.endpointService.httpOptions
        )
      );

      if (consentGiven) {
        console.log('User consented to GDPR. Consent registered.');
        await this.endpointService.sendRunMigrationsRequest();
        await this.endpointService.sendInsertUserOnSchemaRequest();
        window.location.reload();
      } else {
        console.log('User did not consent to GDPR. Consent registered as denied.');
        this.shown = false;
        window.location.reload();
      }
    } catch (error) {
      console.error('Error registering GDPR consent:', error);
      return false;
    }
    return false;
  }
}
